import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectFieldDefinitionInfoFragment = { __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null };

export const ProjectFieldDefinitionInfo = /*#__PURE__*/ gql`
    fragment ProjectFieldDefinitionInfo on ProjectFieldDefinition {
  configuration {
    ... on NumberFieldConfiguration {
      scale
    }
    ... on RatingFieldConfiguration {
      color
      maxValue
      style
    }
    ... on SelectFieldConfiguration {
      options {
        color
        displayName
        id
      }
    }
    ... on ToggleFieldConfiguration {
      color
    }
    ... on DateFieldConfiguration {
      displayFormat
      displayTimezone
      includeTime
      timeFormat
    }
    ... on UsersFieldConfiguration {
      customMembers {
        id
        type
      }
      memberOptionsType
      notifyMembers
      selectType
    }
    ... on UserFieldConfiguration {
      customMembers {
        id
        type
      }
      memberOptionsType
      notifyMembers
    }
  }
  fieldType
  id
  isDefaultField
  isFilterable
  isGroupable
  isSortable
  isSystemField
  name
}
    ` as unknown as DocumentNode<ProjectFieldDefinitionInfoFragment, unknown>;

        

        
export const useProjectFieldDefinitionInfoFragment = (
  input: string | Omit<UseFragmentOptions<ProjectFieldDefinitionInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectFieldDefinition' } };
    return input;
  })();

  return useFragment<ProjectFieldDefinitionInfoFragment>({
    fragment: ProjectFieldDefinitionInfo,
    fragmentName: 'ProjectFieldDefinitionInfo',
    ...options,
  });
};
  
        